import { inject, Injectable } from '@angular/core';
import {
  ANALYTICS_EVENTS,
  USER_LOGGED_IN_STATUS
} from '../data-models/constants/analytics.constant';
import { adobePageLoadAnalyticsMocks } from './adobe-data-layer.mocks';
import {
  AnalyticsProfile,
  AnalyticsSiteAssets,
  AnalyticsUserAttributes,
  PageLoadAnalytics
} from './analytics.interfaces';
import { AnalyticsService } from './analytics.service';
@Injectable({
  providedIn: 'root'
})
export class ContentBodyAbodeExtendedAnalytics {
  protected isLoggedInGlobal = false;
  loginMethodUtil: string | undefined;
  protected analyticsService = inject(AnalyticsService);
  previousUrl = '';
  previousPageName = '';

  constructor() {
    this.getLastPageTitle();
  }

  setIsLoggedIn(value: boolean): void {
    this.isLoggedInGlobal = value;
  }

  private async getLastPageTitle(): Promise<void> {
    const lastPageUrl = sessionStorage.getItem('qm_last_page');

    if (!lastPageUrl) {
      return;
    }

    const url = new URL(lastPageUrl);
    this.previousPageName = url?.pathname || '';
    this.previousUrl = lastPageUrl;
  }

  populateHomePageAssets(
    site_assets: AnalyticsSiteAssets[],
    isWarmState: boolean,
    analyticsProfile: AnalyticsProfile,
    countryCode: string,
    langCode: string,
    durationSec: string
  ): void {
    const { pathname } = window.document.location;
    const userAttributes = this.getUserAttributes(isWarmState);
    const userProfile = this.isLoggedInGlobal
      ? { profile: analyticsProfile }
      : {};
    const data: PageLoadAnalytics = {
      ...adobePageLoadAnalyticsMocks,
      page: {
        info: {
          ...adobePageLoadAnalyticsMocks.page.info,
          page_url: pathname,
          page_load_time: durationSec,
          country: countryCode,
          language: langCode,
          previous_page_name: this.previousPageName,
          previous_page_url: this.previousUrl
        }
      },
      site_assets: site_assets,
      user: {
        attributes: userAttributes,
        ...userProfile
      }
    };
    this.analyticsService.setAnalytics(data);
  }

  public getUserAttributes(isWarmState: boolean): AnalyticsUserAttributes {
    if (!this.isLoggedInGlobal) {
      return {
        is_logged_in: USER_LOGGED_IN_STATUS.UNAUTHENTICATED
      };
    }
    return {
      is_logged_in: USER_LOGGED_IN_STATUS.AUTHENTICATED,
      login_state: this.getLoginState(isWarmState),
      login_method: this.loginMethodUtil ? 'undefined' : 'SkyMiles'
    };
  }

  private getLoginState(isWarmState: boolean): string {
    if (this.isLoggedInGlobal) return USER_LOGGED_IN_STATUS.HOT;
    return isWarmState
      ? USER_LOGGED_IN_STATUS.WARM
      : USER_LOGGED_IN_STATUS.COLD;
  }

  getContentInfo(clickedElement: HTMLElement): {
    clicked: string;
    parent?: string;
  } {
    const clickedText = clickedElement.textContent?.trim() || '';
    const parentHeader =
      clickedElement
        .closest('a')
        ?.querySelector('.card-headertxt')
        ?.textContent?.trim() || '';

    return {
      clicked: clickedText,
      parent: clickedText === parentHeader ? undefined : parentHeader
    };
  }

  computePageLoadAssetID(component_type: string, index: number): string {
    const paddedIndex = `${index + 1 < 9 ? '0' : ''}${index + 1}`;
    if (component_type.includes(ANALYTICS_EVENTS.HERO)) {
      return ANALYTICS_EVENTS.HERO + paddedIndex;
    }
    if (component_type.includes(ANALYTICS_EVENTS.BANNER)) {
      return ANALYTICS_EVENTS.ASSET_ID_BANNER + paddedIndex;
    }
    return ANALYTICS_EVENTS.TILE + paddedIndex;
  }

  getComponentName(eventDetail: string): string | undefined {
    return eventDetail.includes(ANALYTICS_EVENTS.HERO)
      ? ANALYTICS_EVENTS.HERO
      : eventDetail.includes(ANALYTICS_EVENTS.BANNER)
      ? ANALYTICS_EVENTS.BANNER
      : ANALYTICS_EVENTS.TILE;
  }

  isComponentLink(anchor: HTMLAnchorElement): boolean {
    return (
      anchor.classList.length > 0 &&
      ((anchor.classList.contains('componentLink') &&
        anchor.classList.contains('block')) ||
        anchor.classList.value.trim() ===
          'card-component flex-adjust  componentLink')
    );
  }
}
